import socialLinksConfigurationModule from "../socialLinksConfigurationModule";

function socialLinksConfigurationController(socialLinksConstants, socialLinksService, languageResource, systemFeedbackService) {
    "ngInject";
    var ctrl = this;
    var lastTypeTarget = "";

    ctrl.canAddSocialLink = function () {
        return ctrl.socialLinks.length < Number(ctrl.socialLinkLimit);
    };

    ctrl.addSocialLink = function () {
        ctrl.socialLinks.push({
            id: 0,
            title: "",
            url: "",
            type: "",
            target: {
                id: ctrl.targetId,
                type: ctrl.targetType
            }
        });
    };

    ctrl.setFeedback = function (success, resourceKey, resourceParameters) {
        if (ctrl.v2) {
            var feedbackMessage = languageResource.get(resourceKey, resourceParameters);
            if (success) {
                systemFeedbackService.success(feedbackMessage);
            } else {
                systemFeedbackService.warning(feedbackMessage);
            }
        } else {
            ctrl.feedbackSuccess = success;
            ctrl.feedbackMessage = languageResource.get(resourceKey, resourceParameters);
        }
    };

    var init = function () {
        var key = ctrl.targetType + ":" + ctrl.targetId;
        if (lastTypeTarget === key) {
            return;
        }

        lastTypeTarget = key;
        ctrl.socialLinks = [];

        socialLinksService.getSocialLinks(ctrl.targetType, ctrl.targetId).then(function (socialLinks) {
            ctrl.socialLinks = socialLinks;
        }).catch(function (errorCode) {
            switch (errorCode) {
                case socialLinksConstants.errorCodes.internal.featureDisabled:
                    ctrl.setFeedback(false, "Message.SocialLinksEditDisabledError");
                    break;
                default:
                    ctrl.setFeedback(false, "Message.UnknownError");
                    break;
            }
        });
    };

    ctrl.$onInit = init;
    ctrl.$onChanges = init;
};

socialLinksConfigurationModule.controller("socialLinksConfigurationController", socialLinksConfigurationController);
export default socialLinksConfigurationController;